module.exports = __webpack_public_path__ + "img/icon_user-accent.b1dfb32b.png";